import { render } from "./PrintSettlement.vue?vue&type=template&id=151f9450"
import script from "./PrintSettlement.vue?vue&type=script&lang=js"
export * from "./PrintSettlement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__